import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { ApplicationContextService, AuthenService, ComCtxConstants, ComponentContextService, EntityMetadataService, StorageUpdatedService } from 'tnx-shared';

@Component({
    selector: 'anonymous-app',
    templateUrl: './anonymous-app.component.html',
    styleUrls: ['./anonymous-app.component.scss'],
    providers: [ComponentContextService, EntityMetadataService]
})
export class AnonymousAppComponent implements OnInit {
    readonly USER_KEY = 'user_info';

    constructor(
        private _appContext: ApplicationContextService,
        private _componentContextService: ComponentContextService,
        private _activatedRouter: ActivatedRoute,
        private _applicationContext: ApplicationContextService,
        private _oauthService: OAuthService,
        private _storageUpdatedService: StorageUpdatedService,
        private _authenService: AuthenService,
    ) {
        this._appContext.addRootContext(this._componentContextService, this._activatedRouter);

        this._oauthService.events.subscribe(evt => {
            if (evt.type == 'token_received') {
                // đọc lại từ localstorage ra redirect ở đây
                this._applicationContext.getRootContext().fireReplayEvent(ComCtxConstants.ROOT.USER_READY, true);
                this.completeAuthentication();
            }
            // else if (evt.type === 'logout') {
            //     // cleanup storage
            //     // this._authenService.cleanupLocalStorage();
            //     // this._storageUpdatedService.cleanupStorageService();
            //     this._oauthService.revokeTokenAndLogout(null, true);
            //     this._router.navigateByUrl('');
            // }
            else if (evt.type == 'token_expires') {
                // this._oauthService.tryLogin();
                localStorage.removeItem('user_info');
                localStorage.removeItem('item_detail');
                this._authenService.logout();
                // this._oauthService.logOut();
                // this._router.navigateByUrl('');
            }
        });
    }

    ngOnInit(): void {
    }

    focusTrap(evt, vt) { }

    completeAuthentication() {
        const user = this._oauthService.getIdentityClaims();
        localStorage.setItem(this.USER_KEY, JSON.stringify(user));
        // this.initLoggedMenu();
        // this.getMenuBar();
        this._componentContextService.fireEvent('COMPLETE_AUTHEN', user);
        this._oauthService.setupAutomaticSilentRefresh();
    }

}
